import { h, Fragment, Component } from "preact";
import { useMemo } from 'preact/hooks'
import { observer } from "mobx-react";

import {
  Banner,
//  Results as ResultsComponent,
  withStore,
  withController,
} from "@searchspring/snap-preact-components";

import { DesktopFilterSummary } from "../FilterSummary/DesktopFilterSummary";
import { FeaturedFilter } from "../FilterSummary/FeaturedFilter";
import { ProductCount } from '../FilterSummary/ProductCount';
import { Profile } from "../Profile/Profile";
import { ResultsComponent } from './ResultsComponent';
import { SidebarContents } from "../Sidebar/Sidebar";
import { Toolbar } from "../Toolbar/Toolbar";
import { MediaQuery } from '../Helpers/MediaQuery';

import "./results.css";


@withStore
@withController
@observer
export class ResultsWrapper extends Component {
  render() {
    const { merchandising, results, pagination, filters } = this.props.store;
    const controller = this.props.controller;

    let leftColumnLayout = window.Resources.searchspring.toolbar.leftColumnLayout;
    if (leftColumnLayout == 'false') {
      leftColumnLayout = "";
    }

    return (
      <div class={(leftColumnLayout ? 'ss-results-left-column left-column-wrapper' : 'ss-results')}>
        <Banner content={merchandising.content} type="header" />
        <Banner content={merchandising.content} type="banner" />

        {(pagination.totalResults > 0 || filters.length > 0) &&
          <FilterUI />
        }

        <div class="clear"></div>

        <Profile name="results" controller={controller}>
          {this.props.children}
        </Profile>

        <div class="clear"></div>
      </div>
    );
  } 
}

@withStore
@withController
@observer
class FilterUI extends Component {
  render() {
    const { merchandising, results, pagination } = this.props.store;
    const controller = this.props.controller;

    return (
      <>
        <FeaturedFilter />

        { this.props.leftColumnLayout ? (
          <MediaQuery query="(min-width: 1024px)">
            <div className="ss-results__top-wrapper page-width">
              <span class="left-hand">
                <ProductCount />
                <DesktopFilterSummary />
              </span>
              <Toolbar />
            </div>
          </MediaQuery>
        ) : (
          <MediaQuery query="(min-width: 1024px)">
            <div className="ss-results__top-wrapper page-width">
              <ProductCount />
              <Toolbar />
            </div>
          </MediaQuery>
        )
        }

        { !this.props.leftColumnLayout ? (
          <MediaQuery query="(max-width: 1023px)">
            <ProductCount />
            <Toolbar />
          </MediaQuery>
        ) : (null)
        }
      </>
    )
  }
}

@withController
@withStore
@observer
export class Results extends Component {
  componentDidMount() {
    const templateWrapper = document.querySelector(".search-results-template-wrapper");

    if (templateWrapper) {
      templateWrapper.classList.add("some-results");
      templateWrapper.classList.remove('no-results');
    }
  }

  render() {
    const { results } = this.props.store;
    const controller = this.props.controller;

    return (
      <>
        { this.props.leftColumnLayout ? (
          <SidebarContents leftColumnLayout={this.props.leftColumnLayout} />
        ): (
          null
        )}
        <ResultsComponent
          className="page-width"
          controller={controller}
          results={results}
        />
      </>
    );
  }
}

@withController
@withStore
@observer
export class NoResults extends Component {
  componentDidMount() {
    const templateWrapper = document.querySelector('.search-results-template-wrapper')

    if (templateWrapper) {
      templateWrapper.classList.add('no-results');
      templateWrapper.classList.remove('some-results');
    }
  }

  render() {
    const { filters } = this.props.store;
    let leftColumnLayout = window.Resources.searchspring.toolbar.leftColumnLayout;
    if (leftColumnLayout == 'false') {
      leftColumnLayout = "";
    }

    return ( 
      (filters.length > 0) && 
      <div className="center">
        <h2 className="ss-title ss-results-title ss-no-results-title headline-medium">No Results for your filter selection.</h2>
        <span className="no-filter-results-header-message body-medium">Please adjust your filters.</span>
      </div>
    );
  }
}
